/**
 * Created by joerg on 20.05.17.
 */

import {observable} from 'mobx';
import shortid from 'shortid'
import Utils from '../utils/Utils'
import numeral from 'numeral/numeral'
import 'numeral/locales'
export default class OutputModel {
    @observable headline;
    @observable title;
    @observable value;
    @observable einheit;
    @observable disabled;
    key;

    constructor(headline = "",title = "Ohne Titel", value = 0.0, einheit, disabled = false) {
        this.headline = headline;
        this.title = title;
        this.value = value;
        this.einheit = einheit;
        this.disabled = disabled;
        this.key = shortid.generate()

    }
    getCombinedVal() {
        numeral.locale('de');
        var fval;
        if(this.einheit === "€"){
            fval = numeral(Math.round(this.value)).format('0,0[.]00 $');
        }else{
            fval = numeral(Math.round(this.value)).format('0,0[.]00 ') +' '+ this.einheit ;
        }
        return Utils.stripTags(fval.toString()) ;
    }
    getFormattedVal(){
        numeral.locale('de');
        var fval;
        if(this.einheit === "€"){
            fval = numeral(Math.round(this.value)).format('0,0[.]00 $');
        }else{
            fval = numeral(Math.round(this.value)).format('0,0[.]00 ') ;
        }
        return Utils.stripTags(fval.toString()) ;
    }
    getTitleStripped(){
        return Utils.stripTags(this.title);
    }
}


// WEBPACK FOOTER //
// ./src/models/OutputModel.js